module.exports = __webpack_public_path__ + "static/Nodejs-6c8a9665ee8a3e251bad53748815cedd.png";